'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.dayBefore;


// WEBPACK FOOTER //
// ./~/sugar-date/number/dayBefore.js